function fallbackCompareStrings(a, b) {
    return a.localeCompare(b);
}
function makeCompareStringsFn() {
    let compareStrings = fallbackCompareStrings;
    if (typeof Intl === 'object' && Intl.hasOwnProperty('Collator')) {
        try {
            const collator = Intl.Collator('en-US');
            compareStrings = collator.compare;
        }
        catch (_e) { }
    }
    return compareStrings;
}
export const stringCompare = makeCompareStringsFn();
//# sourceMappingURL=strings.js.map